import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PenLine, X } from "lucide-react";

// Post-approval story prompt: gentle dashboard card nudging the volunteer to
// share an impact story about a freshly approved hour log. Server enforces
// frequency capping (max 1/week, never twice per log, skipped when a story
// already exists — see routers/hours._maybe_story_nudge). Renders inline, so
// if a celebration modal fires for the same approval it takes the screen
// first and this card is simply what remains after — queued, never stacked.
export function StoryNudgeCard() {
  const [nudge, setNudge] = useState(null);
  useEffect(() => {
    api.storyNudge().then((d) => setNudge(d?.nudge || null)).catch(() => {});
  }, []);
  if (!nudge) return null;

  const dismiss = () => {
    api.dismissStoryNudge(nudge.id).catch(() => {});
    setNudge(null);
  };

  return (
    <div data-testid="story-nudge-card" className="mt-4 mb-6 bg-forest/5 border border-forest/15 rounded-2xl p-5 flex items-start gap-4">
      <div className="w-9 h-9 rounded-full bg-forest/10 flex items-center justify-center shrink-0">
        <PenLine className="w-4 h-4 text-forest" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-xs uppercase tracking-[0.2em] text-forest/70 font-bold">Share your impact story</div>
        <p data-testid="story-nudge-body" className="text-sm text-neutral-700 mt-1">{nudge.body}</p>
        <Link
          to={`/stories?compose=impact&log=${nudge.hour_log_id}`}
          data-testid="story-nudge-write-btn"
          className="inline-flex items-center gap-1.5 mt-3 text-sm font-medium text-white bg-forest hover:bg-forest-hover rounded-full h-9 px-4 transition-colors"
        >
          <PenLine className="w-3.5 h-3.5" /> Share your story
        </Link>
      </div>
      <button
        data-testid="story-nudge-dismiss"
        onClick={dismiss}
        aria-label="Dismiss story prompt"
        className="text-neutral-400 hover:text-forest transition-colors shrink-0"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
